import React, { useCallback, useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ToastContainer } from 'react-toastify';
import Request from '../../../shared/request/Request';
import ToasterHelper from '../../../shared/helpers/toaster.helper';
import { GRID } from '../../../shared/constants/Grid';
import { API } from '../../../shared/constants/API';
import Redirect from '../../redirect/redirect';
import { getItem } from '../../../services/session-storage.service';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import { HttpStatusCode } from '../../../shared/request/HttpStatusCode';
import { Dialog } from 'primereact/dialog';
import 'primeicons/primeicons.css';
import dayjs from 'dayjs';

const BackOfficeUsers = () => {
  const dateOfBirthDateTemplate = row => {
    return dayjs(row.dateOfBirth).format('YYYY-MM-DD');
  };
  const columns = [
    { field: 'id', header: 'Id', width: '0%', hidden: true },
    /*{ field: 'countryId', header: 'CountryId', width: '10%', bodyClassName: 'centre-text' },
    { field: 'roleId', header: 'RoleId', width: '10%', bodyClassName: 'centre-text' },*/
    { field: 'name', header: 'Name', width: '10%', bodyClassName: 'centre-text' },
    { field: 'email', header: 'Email', width: '10%', bodyClassName: 'centre-text' },
    /*{ field: 'password', header: 'Password', width: '10%', bodyClassName: 'centre-text' },*/
    { field: 'dateOfBirth', header: 'Date of Birth', width: '10%', bodyClassName: 'centre-text', body: dateOfBirthDateTemplate },
    /*{ field: 'createdAt', header: 'CreatedAt', width: '10%', bodyClassName: 'centre-text' },
    { field: 'updatedAt', header: 'UpdatedAt', width: '10%', bodyClassName: 'centre-text' },*/
    { field: 'isActive', header: 'Is Active', width: '10%', bodyClassName: 'centre-text' },
    { field: 'isBackOffice', header: 'Is Back Office', width: '10%', bodyClassName: 'centre-text' }
  ];

  const token = getItem('token');
  const { t } = useTranslation();
  const [userName, setUserName] = useState('');
  const [loaded, setLoaded] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(GRID.pageSize);
  const [validated, setValidated] = useState(false);
  const [isUserModalVisible, setIsUserModalVisible] = useState(false);
  const [userDetails, setUserDetails] = useState(null);

  var years = [];
  var date = new Date();
  const [year, setYear] = useState(date.getFullYear().toString());
  const startingYear = 1930;
  for (var i = date.getFullYear(); i >= startingYear; i--) {
    years.push(i.toString());
  }

  const loadData = useCallback(
    async (pageNum: number = pageNumber, pageSizing: number = pageSize, nameToSearch: string = userName, yearToSearch: string = year) => {
      Request.get(
        `${API.BACK_OFFICE_SERVICE}/getUsers?pageNumber=${pageNum}&pageSize=${pageSizing}&name=${nameToSearch}&year=${yearToSearch}`,
        {}
      )
        .then((response: any) => {
          if (response.status.toString() === HttpStatusCode.OK) {
            setRowData(response.body.users);
            setTotalRows(response.body.total);
          } else {
            if (response.status.toString() === HttpStatusCode.TOO_MANY_REQUESTS) {
              ToasterHelper.notify(t('ERRORS.TRY_AGAIN_LATER'), 'info');
            }
            return [];
          }
        })
        .catch(error => {
          ToasterHelper.notify(t('ERRORS.AN_ERROR_OCCURRED'), 'error');
          console.log(error);
          return [];
        });
    },
    [userName, t, year, pageNumber, pageSize]
  );

  useEffect(() => {
    if (!loaded) {
      setLoaded(true);
      loadData();
    }
  }, [loadData, loaded]);

  const validateName = (event: any) => {
    if (event.target.value.length >= 2) {
      setUserName(event.target.value);
      loadData(pageNumber, pageSize, event.target.value, year);
    }
    event.preventDefault();
  };

  const changeYear = (event: any) => {
    setYear(event.target.value);
    loadData(pageNumber, pageSize, userName, event.target.value);
  };

  const onPageChange = (rowData: any) => {
    console.log(rowData);
    setPageSize(rowData.rows);
    setPageNumber(rowData.page + 1);
    loadData(rowData.page + 1, rowData.rows, userName, year);
  };

  const openUserModal = () => {
    resetValues();
    setIsUserModalVisible(true);
  };

  const onCreateUser = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;

    if (form.checkValidity() === true) {
      if (!userName) {
        return;
      }

      Request.post(`${API.BACK_OFFICE_SERVICE}/createUser`, {
        body: {
          name: userName
        }
      })
        .then((response: any) => {
          if (response.status.toString() === HttpStatusCode.TOO_MANY_REQUESTS) {
            ToasterHelper.notify(t('ERRORS.TRY_AGAIN_LATER'), 'info');
          } else if (response.status.toString() !== HttpStatusCode.OK) {
            ToasterHelper.notify(t('ERRORS.AN_ERROR_OCCURRED'), 'error');
          } else {
            setIsUserModalVisible(false);
            setUserName('');
            loadData();
          }
        })
        .catch(error => {
          ToasterHelper.notify(t('ERRORS.AN_ERROR_OCCURRED'), 'error');
          console.log(error);
          return [];
        });
    }
    setValidated(true);
  };

  const resetValues = () => {
    setUserDetails(null);
  };

  return (
    <>
      {!token && <Redirect path='/admin/signin' />}
      <div className='main-div'>
        <ToastContainer />
        <div className='main-content'>
          <h3>{t('BACK_OFFICE.USERS.USERS_LIST')}</h3>
          <div className='col-md-12 flex margin-before-20px'>
            <div className='col-md-1'>{t('COMMON.NAME')}</div>
            <div className='col-md-7'>
              <Form.Group className='mb-6 input-field' controlId='name'>
                <Form.Control type='text' onChange={validateName} placeholder={t('COMMON.NAME')} />
              </Form.Group>
            </div>
            <div className='col-md-1 padding-left-10px'>{t('COMMON.YEAR')}</div>
            <div className='col-md-1'>
              <select value={year} onChange={changeYear} className='select-small'>
                {years.map(option => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
            <div className='col-md-2 right-align-text'>
              <Button className='button-yellow cursor-pointer' onClick={openUserModal}>
                <b>{t('BACK_OFFICE.USERS.CREATE_USER')}</b>
              </Button>
            </div>
          </div>
          <div className='margin-before-20px'>
            <DataTable value={rowData} tableStyle={{ minWidth: '50rem' }} stripedRows lazy>
              {columns.map(col => (
                <Column
                  key={col.field}
                  field={col.field}
                  header={col.header}
                  style={{ width: col.width }}
                  body={col.body}
                  hidden={col.hidden}
                />
              ))}
            </DataTable>
            <Paginator
              first={pageNumber - 1}
              rows={pageSize}
              totalRecords={totalRows}
              rowsPerPageOptions={GRID.rowsPerPageOptions}
              onPageChange={onPageChange}
            />
          </div>
          <div className='card'>
            <Dialog
              header={t('BACK_OFFICE.USERS.CREATE_USER')}
              visible={isUserModalVisible}
              onHide={() => {
                if (!isUserModalVisible) return;
                setIsUserModalVisible(false);
              }}
              style={{ width: '75vw' }}
              breakpoints={{ '750px': '75vw', '641px': '100vw' }}>
              <Form noValidate validated={validated} onSubmit={onCreateUser}>
                <div className='col-md-12 flex'>
                  <div className='col-md-2'>{t('BACK_OFFICE.USERS.USER_NAME')}</div>
                  <div className='col-md-4'>
                    <Form.Group className='mb-6 input-field' controlId='UserName'>
                      <Form.Control
                        type='text'
                        required
                        value={userDetails?.name}
                        onChange={validateName}
                        placeholder={t('BACK_OFFICE.USERS.USER_NAME')}
                      />
                    </Form.Group>
                  </div>
                </div>
                <div className='col-md-12 margin-before-20px right-align-text'>
                  <Button className='button-yellow cursor-pointer' onClick={() => setIsUserModalVisible(true)}>
                    <b>{t('COMMON.SUBMIT')}</b>
                  </Button>
                </div>
              </Form>
            </Dialog>
          </div>
        </div>
      </div>
    </>
  );
};

export default BackOfficeUsers;
